import { IRegions, ISubRegion } from "api/types/_region";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import FeatherIcon from "feather-icons-react";

interface ModalHashTagProps {
  textButtonClose?: string;
  textButtonConfirm?: string;
  isLoading?: boolean;
  regions?: any;
  listHashtag?: any;
  lstRegionSelected?: any;
  onClose?: () => void;
  onConfirm?: (lstRegion: any) => void;
}

const ModalRegion = ({
  isLoading = false,
  regions,
  lstRegionSelected,
  onClose,
  onConfirm,
}: ModalHashTagProps) => {
  const { t } = useTranslation();

  const [lstRegion, setLstRegion] = useState<any[] | []>([]);
  const [expandedNodes, setExpandedNodes] = useState<{ [key: string]: boolean }>({});
  const [checkedItems, setCheckedItems] = useState<any>({});

  // console.log(JSON.stringify(lstRegionSelected));
 
  useEffect(() => {
    if(lstRegionSelected) {
      const formatData = () => {
        const result = {} as any;
  
        lstRegionSelected?.forEach((item:any) => {
          const { regionId, subRegionId, label } = item;
  
          if (subRegionId) {
            const [region, subRegion] = label?.split(' - ')?.map((str: any) => str.trim());
            if (!result[regionId]) {
              result[regionId] = {
                checked: true,
                label: region
              };
            }
  
            result[`${regionId}-${subRegionId}`] = {
              checked: true,
              label: subRegion
            };
          } else {
            result[regionId] = {
              checked: true,
              label: label
            };
          }
        });
  
        return result;
      };
      setCheckedItems(formatData());
    }
  }, [lstRegionSelected]);

  function CheckboxTreeNode({ node, checkedItems, onCheck }: any) {
    const isChecked = checkedItems[node.id]?.checked || false;
    const isIndeterminate = checkedItems[node.id]?.indeterminate || false;
    const isExpanded = expandedNodes[node.id] || false; // Default to true

    const handleCheck = () => {
      onCheck(node.id, !isChecked);
    };

    const handleToggle = () => {
      setExpandedNodes((prev) => ({
        ...prev,
        [node.id]: !isExpanded,
      }));
    };

    return (
      <div className="ml-4" style={{ marginLeft: 8 }}>
        <label className="flex items-center space-x-2" style={{whiteSpace: "nowrap"}}>
          {node?.subRegions && node?.subRegions?.length > 0 ? (
            <FeatherIcon
              icon={isExpanded ? "chevron-down" : "chevron-up"}
              className="icon-dual"
              onClick={handleToggle}
              style={{ marginRight: 5 }}
            />
          ) : (
            <span style={{ width: 16, display: "inline-block" }} /> // Placeholder để căn chỉnh
          )}

          <input
            type="checkbox"
            checked={isChecked}
            ref={(el) => {
              // if (el) el.indeterminate = isIndeterminate;
            }}
            onChange={handleCheck}
            className="form-check-input h-4 w-4 text-blue-600 border-gray-300 cursor-pointer"
          />

          <span className="text-gray-700" style={{ paddingLeft: 5, whiteSpace: "nowrap" }}>
            {node?.name}
          </span>
        </label>
        {node?.subRegions && isExpanded && (
          <div
            className="ml-4 d-grid gap-2"
            style={{ marginLeft: 16, gridTemplateColumns: "repeat(2, 1fr)" }}
          >
            {node?.subRegions.map((child: any) => (
              <CheckboxTreeNode
                key={child.id}
                node={child}
                checkedItems={checkedItems}
                onCheck={onCheck}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  const updateCheckedState = (
    node: any,
    isChecked: any,
    newCheckedItems: any,
  ) => {
    newCheckedItems[node.id] = {
      checked: isChecked,
      label: node.name,
    };

    if (node.subRegions) {
      node.subRegions.forEach((child: any) => {
        updateCheckedState(child, isChecked, newCheckedItems);
      });
    }
  };

  const findParent = (nodeId: any, nodes: any) => {
    for (const node of nodes) {
      if (node.subRegions?.some((child: any) => child.id === nodeId)) {
        return node;
      }
      if (node.subRegions) {
        const parent = findParent(nodeId, node.subRegions) as any;
        if (parent) return parent;
      }
    }
    return null;
  };

  const updateParentState = (node: any, nodes: any, newCheckedItems: any) => {
    if (!node.subRegions) return;

    const childStates = node.subRegions.map((child: any) => ({
      checked: newCheckedItems[child.id]?.checked || false,
      label: child.name,
    }));

    const allChecked = childStates.every((state: any) => state.checked);
    const someChecked = childStates.some(
      (state: any) => state.checked
    );

    newCheckedItems[node.id] = {
      checked: allChecked || someChecked,
      label: node.name,
    };

    const parent = findParent(node.id, nodes);
    if (parent) {
      updateParentState(parent, nodes, newCheckedItems);
    }
  };

  const ensureParentChecked = (
    nodeId: any,
    nodes: any,
    newCheckedItems: any
  ) => {
    const parent = findParent(nodeId, nodes);
    if (parent) {
      newCheckedItems[parent.id] = {
        checked: true,
        label: parent.name,
      };
      ensureParentChecked(parent.id, nodes, newCheckedItems);
    }
  };

  const handleCheck = (id: any, isChecked: any) => {
    const newCheckedItems = { ...checkedItems } as any;
    const node =
      lstRegion
        .flatMap((n: any) => [n, ...(n?.subRegions || [])])
        .find((n) => n.id === id) ||
      (lstRegion
        .find((n) => n?.subRegions?.some((child: any) => child.id === id))
        ?.subRegions.find((child: any) => child.id === id) as any);

    if (node?.subRegions) {
      updateCheckedState(node, isChecked, newCheckedItems);
    } else {
      console.log(node)
      newCheckedItems[node.id] = {
        checked: isChecked,
        label: node.name,
      };
      if (isChecked) {
        ensureParentChecked(node.id, lstRegion, newCheckedItems);
      }
    }

    updateParentState(node, lstRegion, newCheckedItems);
    setCheckedItems(newCheckedItems);
  };

  const handleCloseConfirmClick = () => {
    onClose && onClose();
  };

  useEffect(() => {
    if (regions) {
      const formatRegion = regions?.map((item: IRegions) => {
        let newSubRegion = [] as any;
        if(item?.subRegions && item?.subRegions?.length > 0) {
          newSubRegion = item?.subRegions?.map((sub: ISubRegion) => ({
            ...sub,
            id: `${item?.id}-${sub?.id}`
          }))
        }

        return {
          ...item,
          subRegions: newSubRegion
        }
      })
      setLstRegion(formatRegion);
      // Initialize expandedNodes with all node IDs set to true
      const initialExpanded: { [key: string]: boolean } = {};
      const traverseNodes = (nodes: any[]) => {
        nodes.forEach((node) => {
          initialExpanded[node.id] = true;
          if (node.subRegions && node.subRegions.length > 0) {
            traverseNodes(node.subRegions);
          }
        });
      };
      traverseNodes(regions);
      setExpandedNodes(initialExpanded);
    }
  }, [regions]);

  const handleActionConfirm = () => {
    const formatCheckedItems = Object.keys(checkedItems).filter(key => checkedItems[key]?.checked === true);
    const regionIdsWithSub = new Set(formatCheckedItems.filter(key => key.includes("-")).map(key => key.split("-")[0]));
    
    const result = formatCheckedItems.reduce((acc: any, key: any) => {
      if (key.includes("-")) {
        const [regionId, subRegionId] = key.split("-");
        const getNameRegion = [checkedItems[regionId]?.label, checkedItems[key]?.label].filter(Boolean).join(" - ");

        acc.push({ regionId: Number(regionId), subRegionId: Number(subRegionId), label: getNameRegion  });
      } else if (!regionIdsWithSub.has(key)) {
        acc.push({ regionId: Number(key), label: checkedItems[key]?.label || "" });
      }
      return acc;
    }, []);

    onConfirm && onConfirm(result)
  }

  return (
    <React.Fragment>
      <Modal
        isOpen={true}
        centered={true}
        size="md"
        toggle={handleCloseConfirmClick}
        keyboard={true}
        scrollable={true}
      >
        <ModalHeader toggle={isLoading ? () => {} : handleCloseConfirmClick}>
          <Row className="g-4 align-items-center">
            <div>{t("List Regions")}</div>
          </Row>
        </ModalHeader>
        <div className=" position-relative" style={{paddingRight: 22, top: "-15px"}}>
          <div className="col-12 con-sm-6 text-end">
            <button
              className={`btn btn-primary fs-14`}
              type="button"
              disabled={isLoading}
              onClick={() => handleActionConfirm()}
            >
              {isLoading ? (
                <Spinner size="sm" className="me-2"></Spinner>
              ) : (
                <i
                  className={`ri-login-circle-line align-bottom me-1`}
                ></i>
              )}
              {t("Button Save")}
            </button>
          </div>
        </div>

        <ModalBody className="">
          <div className="max-w-md mx-auto bg-white rounded-lg position-relative">
            
            
            
            {lstRegion && lstRegion?.length > 0 && lstRegion.map((node) => (
              <CheckboxTreeNode
                key={node.id}
                node={node}
                checkedItems={checkedItems}
                onCheck={handleCheck}
              />
            ))}
            
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalRegion;